import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Link } from '@chakra-ui/react';
import { t } from 'i18next';
import useGetColors from 'shared/hooks/useGetColors';
import Landing from 'shared/views/landing/Index';


interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
}

const MockAiText = ({ isOpen, onClose }: Props) => {
  const { gray800, white, gray100, brand500, brand400 } = useGetColors();

  return (
    <Modal isOpen={isOpen} onClose={(onClose)} size="3xl">
      <ModalOverlay />
      <ModalContent mt="30px">
        <ModalHeader>🚀 Автоматизация маркетинга с живыми чатами и умными инструментами</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Landing isModal />
        </ModalBody>
        <ModalFooter>
          <Button
            color={gray800}
            bgColor={gray100}
            borderRadius="8px"
            onClick={onClose}
            w="100px"
          >
            {t('buttons.cancel')}
          </Button>
          <Link target='_blank' href='https://t.me/LeadBolid_AI'>
            <Button
              color={white}
              bgColor={gray100}
              borderRadius="8px"
              backgroundColor={brand500}
              _hover={{
                background: brand400,
              }}
              ml="20px"
              type="submit"
            >
              {t('ContactManager')}
            </Button>
          </Link>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default MockAiText;